import * as React from 'react'

import { Dropdown } from '@/ui/form/controls/Dropdown'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import {
  getPreferredScanner,
  setPreferredScanner,
  useScannerBridge,
} from '@/modules/imports/container/scan-discs-popup-container/scanner/useScannerBridge'

// Zapisuje się od razu i lokalnie, poza przyciskiem "Zapisz" strony - to ustawienie
// tej przeglądarki, nie firmy. Lista skanerów pochodzi z mostka, więc bez niego
// nie ma z czego wybierać.
export const DefaultScannerField = () => {
  const { t } = useLocalize()
  const { status, scanners, error } = useScannerBridge()
  const [deviceId, setDeviceId] = React.useState<string | null>(getPreferredScanner)

  const handleChange = (value: string) => {
    setDeviceId(value)
    setPreferredScanner(value)
  }

  return (
    <fieldset className="tw-d-form-control tw-w-full">
      <label className="tw-mb-0 tw-px-1 tw-pb-0.5 tw-text-sm tw-font-medium">
        {t('configuration-scanner.default-scanner')}
      </label>

      {status === 'ready' ? (
        <Dropdown
          options={scanners.map((s) => ({ label: s.name, value: s.deviceId }))}
          value={deviceId ?? scanners[0]?.deviceId ?? null}
          onChange={handleChange}
          placeholder={t('configuration-scanner.select-scanner')}
        />
      ) : (
        <p className="tw-px-1 tw-py-2 tw-text-sm tw-text-content-base/60">
          {status === 'checking' && t('configuration-scanner.looking-for-scanners')}
          {status === 'unavailable' && t('configuration-scanner.no-bridge')}
          {status === 'no-scanner' && t('configuration-scanner.no-scanner')}
          {status === 'error' && (error ?? t('configuration-scanner.bridge-error'))}
        </p>
      )}

      <span className="tw-px-1 tw-pt-0.5 tw-text-xs tw-text-content-base/60">
        {t('configuration-scanner.default-scanner-hint')}
      </span>
    </fieldset>
  )
}
